<template>
  <div class="py-8">
    <div class="mb-6 flex space-x-2 text-sm">
      <UiSkeleton class="h-4 w-20" />
      <UiSkeleton class="h-4 w-3" />
      <UiSkeleton class="h-4 w-24" />
      <UiSkeleton class="h-4 w-3" />
      <UiSkeleton class="h-4 w-16" />
    </div>

    <div class="flex flex-col md:flex-row md:space-x-8">
      <div class="mb-8 w-full md:mb-0 md:w-1/4">
        <UiSkeleton class="mb-4 h-6 w-32" />

        <UiSkeleton class="mb-2 h-5 w-20" />
        <div class="mb-6 flex space-x-2">
          <UiSkeleton class="h-10 w-1/2 rounded-md" />
          <UiSkeleton class="h-10 w-1/2 rounded-md" />
        </div>

        <div v-for="i in 7" :key="i" class="mb-6">
          <UiSkeleton class="h-5 w-32" />
        </div>

        <div class="mt-8 flex flex-col space-y-3">
          <UiSkeleton class="h-10 w-full rounded-full" />
          <UiSkeleton class="h-10 w-full rounded-full" />
        </div>
      </div>

      <div class="w-full md:w-3/4">
        <div class="mb-6 flex items-center justify-between">
          <UiSkeleton class="h-5 w-40" />
          <UiSkeleton class="h-10 w-28 rounded-md" />
        </div>

        <div class="grid grid-cols-2 gap-6 md:grid-cols-3">
          <div v-for="i in 9" :key="i" class="flex flex-col">
            <UiSkeleton class="mb-3 h-72 w-full rounded-md" />
            <UiSkeleton class="mb-1 h-5 w-3/4" />
            <UiSkeleton class="h-5 w-16" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
